import { type EventContentObjectDetail, type ProgramEventInvitee, isRegisteredProgramInvitee } from 'models';
import { Avatar, Button, Col, DotSeparator, Dropdown, Icon, Row, Text } from 'ui';
import { useUser } from 'features/auth';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { AvatarLink, UserLink, UserPopover } from 'features/users/components';
import { EventInviteeName } from '../../../event-invitee-name';
import { useGetInviteesBadgeIcon, useGetInviteesInformation, useInviteesActions } from '../hooks';

type P = {
  eventContentObject: EventContentObjectDetail;
  invitee: ProgramEventInvitee;
};

const EventAttendee = ({ eventContentObject, invitee }: P) => {
  const getInviteesInformation = useGetInviteesInformation({ isTelehealth: false });
  const getBadgeIcon = useGetInviteesBadgeIcon();
  const { railsUserData: viewer } = useUser({ requiredAuth: true });

  const { contextHolder, getInviteesActions, isLoadingAction } = useInviteesActions();

  const actions = getInviteesActions({
    currentInvitee: invitee,
    eventContentObject,
    viewer,
  });

  return (
    <Row
      align="middle"
      className="event-invitees-list-item"
      justify="space-between"
      key={isRegisteredProgramInvitee(invitee) ? invitee.id : invitee.email}
    >
      <Col>
        {isRegisteredProgramInvitee(invitee) ? (
          <UserPopover user={invitee}>
            <AvatarLink
              avatar={{
                badge: { count: getBadgeIcon({ rsvp: invitee.rsvp }) },
                src: invitee.profilePhoto,
              }}
              userId={invitee.id}
            />
          </UserPopover>
        ) : (
          <Avatar badge={{ count: getBadgeIcon({ rsvp: invitee.rsvp }) }} />
        )}
      </Col>
      <Col flex="1 1 0">
        <Row>
          <Col span={24}>
            {isRegisteredProgramInvitee(invitee) ? (
              <UserPopover user={invitee}>
                <UserLink userId={invitee.id}>
                  <EventInviteeName invitee={invitee} viewerId={viewer.id} />
                </UserLink>
              </UserPopover>
            ) : (
              <Text type="title" weight="medium">
                {invitee.email}
              </Text>
            )}
          </Col>
          <Col span={24}>
            <Text size="small">
              <DotSeparator items={getInviteesInformation({ role: invitee.eventRole, rsvp: invitee.rsvp })} />
            </Text>
          </Col>
        </Row>
      </Col>
      {actions.length > 0 ? (
        <Col>
          <Dropdown
            menu={{
              items: actions,
            }}
            trigger={['click']}
          >
            <Button icon={<Icon color="text" icon="more-2-line" />} loading={isLoadingAction} type="link-secondary" />
          </Dropdown>
        </Col>
      ) : null}
      {contextHolder}
    </Row>
  );
};

export default EventAttendee;
